export default function inIframe() {
  return window != window.top;
}
